<template>
  <nav class="header-container">
    <app-header-navigation
      :menu-items="menuItems"
      :menu-items-more-info="menuItemsMoreInfo"
      class="header-navigation"
    />
    <div class="header-right">
      <app-header-combobox-schoolyear v-if="isEMISAccount && isTeacher" />
      <app-header-material
        v-if="isTeacher"
        :menu-items="menuItems"
      />
      <app-header-setting v-if="isTeacher" />

      <app-header-help />
      <app-header-cart v-if="!isTeacher" />
      <app-header-notify />
      <app-header-user class="header-user">
        <template #user-popover>
          <slot name="user-popover" />
        </template>
      </app-header-user>
    </div>
  </nav>
</template>

<script>
import AppHeaderNavigation from './app-header-navigation.vue'
import AppHeaderUser from './app-header-user'
import AppHeaderNotify from './app-header-notify'
import AppHeaderHelp from './app-header-help'
import AppHeaderCart from './app-header-cart'
import AppHeaderSetting from './app-header-setting'
import AppHeaderMaterial from './app-header-material'
import AppHeaderComboboxSchoolyear from './app-header-combobox-schoolyear'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { getUserType } from '@/utils/auth'
import { UserType } from '@/common/constant'
import { emptyUuid } from '@/utils/uuid'

export default {
  components: {
    AppHeaderNavigation,
    AppHeaderUser,
    AppHeaderNotify,
    AppHeaderHelp,
    AppHeaderCart,
    AppHeaderSetting,
    AppHeaderMaterial,
    AppHeaderComboboxSchoolyear
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    menuItemsMoreInfo: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    /**
     * Là giáo viên
     */
    isTeacher () {
      return getUserType() === UserType.Teacher
    },

    // Kiểm tra tài khoản có phải bên EMIS hay không
    isEMISAccount () {
      return getContextData(ContextDataKey.IsEMIS) || getContextData(ContextDataKey.OrganizationID) !== emptyUuid
    }

  }
}
</script>

<style lang="scss" scoped>
.header-container {
  height: 100%;
  display: flex;
  align-items: center;

  // .header-navigation {
  //   font-weight: 600; //sửa theo yêu cầu của QC TTNgan
  // }

  .header-right {
    height: 100%;
    width: auto;
    display: flex;
    align-items: center;
  }
}
</style>
